import { render, staticRenderFns } from "./StepCounter.vue?vue&type=template&id=37050790&scoped=true"
import script from "./StepCounter.vue?vue&type=script&lang=js"
export * from "./StepCounter.vue?vue&type=script&lang=js"
import style0 from "./StepCounter.vue?vue&type=style&index=0&id=37050790&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37050790",
  null
  
)

export default component.exports